export const KPI_NUMBER_OF_DAILY_HOURS = 12;
export const KPI_ATTACHMENTS_COLLECTION_NAME = 'workpack';
export const KPI_NOTE_LOG_METADATA_KEY = 'kpiLogDate';
export const KPI_NOTE_LOG_SHIFT_METADATA_KEY = 'kpiLogShift';
export const KPI_POB_FIELD_KEY = 'pob' as const;
export const KPI_CONFIG_SECTION_KEY = 'config';
